"use client";
import React from 'react';
import Image from "next/image";
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

export default function TeamGallery() {
  const t = useTranslations('plsyy');

  // 团队照片数据
  const teamPhotos = [
    {
      id: 1,
      image: "/image/plsyy/about/team-1.webp",
      alt: "Team Photo 1"
    },
    {
      id: 2,
      image: "/image/plsyy/about/team-2.webp",
      alt: "Team Photo 2"
    },
    {
      id: 3,
      image: "/image/plsyy/about/team-3.webp",
      alt: "Team Photo 3"
    },
    {
      id: 4,
      image: "/image/plsyy/about/team-4.webp",
      alt: "Team Photo 4"
    },
    {
      id: 5,
      image: "/image/plsyy/about/team-5.webp",
      alt: "Team Photo 5"
    },
    {
      id: 6,
      image: "/image/plsyy/about/team-6.webp",
      alt: "Team Photo 6"
    }
  ];

  return (
    <section id="team-gallery" className='py-16 max-md:py-10 bg-[#f8f9fa] scroll-mt-40'>
      <div className="container mx-auto px-4 max-md:px-4">
        {/* 标题区域 */}
        <motion.div 
          className="pb-6 sm:pb-8 md:pb-10 text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl sm:text-3xl xl:text-4xl font-bold text-black leading-tight text-center mb-3 sm:mb-4">
            {t('Team-Gallery-Title')}
          </h2>
        </motion.div>

        {/* 照片网格 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-md:gap-3">
          {teamPhotos.map((photo, index) => (
            <motion.div
              key={photo.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ 
                duration: 0.6,
                delay: index * 0.1
              }}
              className="relative w-full aspect-[4/3] overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 group"
            >
              <Image
                src={photo.image}
                alt={photo.alt}
                fill
                quality={90}
                className="object-cover group-hover:scale-105 transition-transform duration-300"
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

